import React from 'react';
import { Dot } from 'react-animated-dots';

export default function Loader() {
  const dotStyle = {
    fontSize: '42px',   // Increase dot size
    color: 'grey',       // Change dot color
    marginRight: '4px'  // Optional: spacing between dots
  };

  return (
    <div>
      <p className='processing-text' style={{ display: 'flex', alignItems: 'center', fontSize: '15px', marginTop: '18px' }}>
        Processing
        <span style={{ display: 'flex', marginLeft: '10px', marginBottom: '22px' }}>
          <Dot style={dotStyle}>.</Dot>
          <Dot style={dotStyle}>.</Dot>
          <Dot style={dotStyle}>.</Dot>
        </span>
      </p>
    </div>
  );
}
